import { EMPTY_LIST } from '../../../constants/common'
import { getSkeletonFiles } from '../File.utils'

import { getFileListItemKey } from './FileList.constants'

import * as styles from './FileList.module.css'

function FileList({
  children,
  className = styles.FileList,
  errorItems = EMPTY_LIST,
  files,
  isSkeleton,
  itemClassName = styles.fileListItem,
  renderItem,
  uploadingItems = EMPTY_LIST,
}) {
  const list = isSkeleton
    ? getSkeletonFiles()
    : files.concat(errorItems).concat(uploadingItems)

  return (
    <div className={className}>
      {children}
      {list.map((f, index) => {
        return (
          <div className={itemClassName} key={getFileListItemKey(f, index)}>
            {renderItem(f, getFileListItemKey(f, index))}
          </div>
        )
      })}
    </div>
  )
}

export default FileList
